import { MicrosoftLoginButton } from "@appretio/auth";
import { Logo } from "@appretio/ui-kit";
import { Divider } from "../../../../packages/ui-kit/src/divider/Divider";
import { CredentialsForm } from "./LoginCredentialsForm";
import {
  copyrightText,
  forgotPasswordLink,
  forgotPasswordText,
  headingText,
  loginContentContainer,
  loginFormContainer,
  loginMainContent,
  loginPageBase,
  logoContainer
} from "./LoginPage.css";

const resetPasswordUrl = "https://example.com/reset-password";

export function LoginPage() {
  return (
    <div className={loginPageBase}>
      <div className={loginMainContent}>
        <div className={loginContentContainer}>
          <div className={logoContainer}>
            <Logo />
          </div>
          <div className={loginFormContainer}>
            <p className={headingText}>Sign in to let the magic begin</p>

            <CredentialsForm />

            <Divider text="Or" />

            <MicrosoftLoginButton />
          </div>
          <p className={forgotPasswordText}>
            Forgot your password? Reset it{" "}
            <a className={forgotPasswordLink} href={resetPasswordUrl}>
              here
            </a>
            .
          </p>
        </div>
      </div>
      <p className={copyrightText}>© Appretio {new Date().getFullYear()}</p>
    </div>
  );
}
